import React, { FC } from 'react';
import { FormattedNumber } from 'react-intl';
import './LabelledNumber.css';

interface Props {
  label: string;
  number: number;
  showPrefix?: boolean;
}

const LabelledNumber: FC<Props> = ({ label, number, showPrefix }) => {
  const isPositive = number >= 0;
  const positiveNumber = Math.abs(number);
  const sign = isPositive ? '+' : '-';
  const className = isPositive ? 'green' : 'red';
  const decimal = (positiveNumber % 1) * 100;
  let decimalString = decimal.toString();
  if (decimal < 10) {
    decimalString = `0${decimalString}`;
  }
  decimalString = `.${decimalString.substring(0, 2)}`;

  return (
    <div className="labelled-number">
      <div className="number">
        {showPrefix && (
          <span className={`${className} upper sign`}>{sign}</span>
        )}
        <div className="main-number">
          <FormattedNumber
            minimumFractionDigits={0}
            maximumFractionDigits={0}
            value={Math.floor(positiveNumber)}
          />
        </div>
        <span className="upper decimal">{decimalString}</span>
      </div>
      <div className="number-label">{label}</div>
    </div>
  );
};

export default LabelledNumber;
